import { useSelector } from '~Hooks';
import _ from 'lodash';

export const useSplitPayment = (orderId: string) => {
  const splitOrder = useSelector((state) => state.POSSplitOrder);
  const POSPayments = useSelector((state) =>
    state.POSPayments.filter((payment) => payment.order === orderId),
  );

  // Latest payment that was made
  const latestSplitPayment = splitOrder?.payments[splitOrder.payments.length - 1];
  const latestPOSPayment =
    latestSplitPayment && POSPayments.find((payment) => payment.id === latestSplitPayment.id);

  // Finds latest payment that is not marked refunded
  const nextRefundPayment = splitOrder
    ? _.findLast(splitOrder.payments, (payment) => !payment.refunded)
    : undefined;

  // Sums up the amount of all finished payments
  const amountPaid =
    splitOrder?.payments.reduce((acc, payment) => {
      const POSPayment = POSPayments.find((p) => p.id === payment.id);
      if (POSPayment && POSPayment.status === 'COMPLETED') {
        return acc + payment.amount;
      }
      return acc;
    }, 0) ?? 0;

  return {
    splitOrder,
    latestSplitPayment,
    latestPOSPayment,
    nextRefundPayment,
    amountPaid,
    /* needed to get tips of the subpayments */
    orderPOSPayments: POSPayments,
  };
};
